// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"1":"724a750d","85":"97e85756","186":"fec9238c","664":"54a1ea72","732":"6cc52543","944":"be1df608"}[chunkId] + ".js";
};